export class HomeView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._unsubscribe = null;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'messenger-view messenger-home-view';

		this._updateContent();

		this._unsubscribe = this.state.subscribe((type) => {
			if (
				type === 'homeChangelogUpdate' ||
				type === 'conversationsUpdate' ||
				type === 'availabilityUpdate'
			) {
				this._updateContent();
			}
		});

		return this.element;
	}

	_updateContent() {
		const avatarsHtml = this._renderAvatarStack();
		const recentChangelogHtml = this._renderRecentChangelog();

		this.element.innerHTML = `
			<div class="messenger-home-scroll">
				<div class="messenger-home-header">
					<div class="messenger-home-header-top">
						<div class="messenger-home-logo">
							${this.options.logoUrl ? `<img src="${this.options.logoUrl}" alt="${this.state.teamName}" />` : ''}
						</div>
						<div class="messenger-home-avatars">${avatarsHtml}</div>
						<button class="sdk-close-btn" aria-label="Close">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256">
								<path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
							</svg>
						</button>
					</div>
					<div class="messenger-home-welcome">
						<span class="messenger-home-greeting">${this.state.greetingMessage}</span>
						<span class="messenger-home-question">${this.state.welcomeMessage}</span>
					</div>
				</div>

				<div class="messenger-home-body">
					${this._renderMessageButton()}
					${this._renderFeaturedCard()}
					${recentChangelogHtml}
				</div>
			</div>
		`;

		this._attachEvents();
	}

	_renderAvatarStack() {
		const avatars = this.state.teamAvatars;
		const colors = ['#5856d6', '#007aff', '#34c759', '#ff9500'];

		if (!avatars || avatars.length === 0) {
			return `
				<div class="messenger-avatar-stack">
					<div class="sdk-avatar sdk-avatar-lg" style="background: ${colors[0]};">S</div>
					<div class="sdk-avatar sdk-avatar-lg" style="background: ${colors[1]};">T</div>
				</div>
			`;
		}

		const avatarItems = avatars
			.slice(0, 4)
			.map((avatar, index) => {
				if (typeof avatar === 'string' && avatar.startsWith('http')) {
					return `<div class="sdk-avatar sdk-avatar-lg"><img src="${avatar}" alt="Team member" /></div>`;
				}
				return `<div class="sdk-avatar sdk-avatar-lg" style="background: ${colors[index % colors.length]};">${avatar.charAt(0).toUpperCase()}</div>`;
			})
			.join('');

		return `<div class="messenger-avatar-stack">${avatarItems}</div>`;
	}

	_renderAvailabilityStatus() {
		const isOnline = this.state.agentsOnline;
		const responseTime =
			this.state.responseTime || 'We typically reply within a few minutes';

		if (isOnline) {
			return `
				<div class="messenger-home-availability">
					<span class="messenger-availability-dot messenger-availability-online"></span>
					<span class="messenger-availability-text">We're online now</span>
				</div>
			`;
		}

		return `
			<div class="messenger-home-availability">
				<span class="messenger-availability-dot messenger-availability-away"></span>
				<span class="messenger-availability-text">${responseTime}</span>
			</div>
		`;
	}

	_renderMessageButton() {
		const openConversation = this.state.conversations.find(
			(c) => c.status === 'open'
		);

		const sendIcon = `
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" style="flex-shrink: 0;">
				<rect width="256" height="256" fill="none"/>
				<line x1="144" y1="128" x2="80" y2="128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
				<path d="M48.49,221.28A8,8,0,0,0,59.93,231l168-96.09a8,8,0,0,0,0-14l-168-95.85a8,8,0,0,0-11.44,9.67L80,128Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
			</svg>
		`;

		const caretIcon = `
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" style="flex-shrink: 0;">
				<rect width="256" height="256" fill="none"/>
				<polyline points="96 48 176 128 96 208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>
			</svg>
		`;

		if (openConversation) {
			return `
				<button class="messenger-home-message-btn messenger-home-continue-btn" data-conversation-id="${openConversation.id}">
					<div class="messenger-home-continue-info">
						<span class="messenger-home-continue-label">Continue conversation</span>
					</div>
					${sendIcon}
				</button>
				<button class="messenger-home-message-btn messenger-feedback-btn" data-action="feedback">
					<span class="messenger-home-continue-label">Leave us feedback</span>
					${caretIcon}
				</button>
			`;
		}

		return `
			<button class="messenger-home-message-btn">
				<span>Start a conversation</span>
				${sendIcon}
			</button>
			<button class="messenger-home-message-btn messenger-feedback-btn" data-action="feedback">
				<span>Leave us feedback</span>
				${caretIcon}
			</button>
		`;
	}

	_renderFeaturedCard() {
		if (!this.options.featuredContent) {
			return '';
		}

		const { title, description, imageUrl, action } =
			this.options.featuredContent;

		return `
			<div class="messenger-home-featured">
				${imageUrl ? `<img src="${imageUrl}" alt="${title}" class="messenger-home-featured-image" onerror="this.style.display='none';" />` : ''}
				<div class="messenger-home-featured-content">
					<h3>${title}</h3>
					<p>${description}</p>
				</div>
				${action ? `<button class="sdk-btn sdk-btn-primary messenger-home-featured-btn" data-action="${action.type}" data-value="${action.value}">${action.label}</button>` : ''}
			</div>
		`;
	}

	_renderRecentChangelog() {
		const changelogItems = this.state.homeChangelogItems;
		if (changelogItems.length === 0) {
			return '';
		}

		const changelogHtml = changelogItems
			.map(
				(item) => `
			<div class="messenger-home-changelog-card" data-changelog-id="${item.id}">
				${
					item.coverImage
						? `
					<div class="messenger-home-changelog-cover">
						<img src="${item.coverImage}" alt="${item.title}" onerror="this.style.display='none';" />
						${item.coverText ? `<span class="messenger-home-changelog-cover-text">${item.coverText}</span>` : ''}
					</div>
				`
						: ''
				}
				<div class="messenger-home-changelog-card-content">
					<h4 class="messenger-home-changelog-card-title">${item.title}</h4>
					<p class="messenger-home-changelog-card-desc">${item.description || ''}</p>
				</div>
			</div>
		`
			)
			.join('');

		return `
			<div class="messenger-home-changelog-section">
				${changelogHtml}
			</div>
		`;
	}

	_formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		const now = new Date();
		const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

		if (diffDays === 0) return 'Today';
		if (diffDays === 1) return 'Yesterday';
		if (diffDays < 7) return `${diffDays}d ago`;
		return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
	}

	_attachEvents() {
		this.element
			.querySelector('.sdk-close-btn')
			.addEventListener('click', () => {
				this.state.setOpen(false);
			});

		const msgBtn = this.element.querySelector(
			'.messenger-home-message-btn:not(.messenger-feedback-btn)'
		);
		if (msgBtn) {
			msgBtn.addEventListener('click', () => {
				const convId = msgBtn.dataset.conversationId;
				if (convId) {
					this.state.setActiveConversation(convId);
					this.state.setView('chat');
					if (this.options.onSelectConversation) {
						this.options.onSelectConversation(convId);
					}
				} else {
					this.state.setActiveConversation(null);
					this.state.setView('chat');
				}
			});
		}

		const feedbackBtn = this.element.querySelector('.messenger-feedback-btn');
		if (feedbackBtn) {
			feedbackBtn.addEventListener('click', () => {
				const url = this.state.urls?.feedback;

				if (this.options.onFeedbackClick) {
					this.options.onFeedbackClick();
				} else if (url) {
					window.open(url, '_blank');
				} else {
					console.warn(
						'[Messenger] No feedback destination configured. Set `feedbackUrl` in MessengerWidget options.'
					);
				}
			});
		}

		this.element
			.querySelectorAll('.messenger-home-changelog-card')
			.forEach((card) => {
				card.addEventListener('click', () => {
					const item = this.state.homeChangelogItems.find(
						(i) => i.id === card.dataset.changelogId
					);
					if (item?.url) {
						window.open(item.url, '_blank');
					} else {
						this.state.setView('changelog');
					}
				});
			});

		const seeAllBtn = this.element.querySelector(
			'.messenger-home-changelog-all'
		);
		if (seeAllBtn) {
			seeAllBtn.addEventListener('click', () => {
				this.state.setView('changelog');
			});
		}

		const featuredBtn = this.element.querySelector(
			'.messenger-home-featured-btn'
		);
		if (featuredBtn) {
			featuredBtn.addEventListener('click', () => {
				const action = featuredBtn.dataset.action;
				const value = featuredBtn.dataset.value;
				if (action === 'url') {
					window.open(value, '_blank');
				} else if (action === 'view') {
					this.state.setView(value);
				}
			});
		}
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
